import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="dark-header">
      <Link to="/" className="logo-container">
        <Logo size="default" />
      </Link>

      {/* Desktop Navigation */}
      <nav className="dark-nav">
        <Link to="/" className={`dark-nav-link ${isActive('/') ? 'active' : ''}`}>
          Home
        </Link>
        <Link to="/about" className={`dark-nav-link ${isActive('/about') ? 'active' : ''}`}>
          About
        </Link>
        <Link to="/services" className={`dark-nav-link ${isActive('/services') ? 'active' : ''}`}>
          Services
        </Link>
        <Link to="/resources" className={`dark-nav-link ${isActive('/resources') ? 'active' : ''}`}>
          Resources
        </Link>
        <Link to="/contact" className="btn-primary" style={{ marginLeft: '16px' }}>
          Get Quote
        </Link>
      </nav>

      {/* Mobile Menu Button */}
      <button 
        className="mobile-menu-btn"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label="Toggle menu"
      >
        {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="mobile-nav">
          <Link to="/" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
            Home
          </Link>
          <Link to="/about" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
            About
          </Link>
          <Link to="/services" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
            Services
          </Link>
          <Link to="/resources" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>
            Resources
          </Link>
          <Link to="/contact" className="btn-primary" onClick={() => setMobileMenuOpen(false)} style={{ width: '100%', marginTop: '12px' }}>
            Get Quote
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;